function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8,5.5c0-1.7,1.3-3.2,3-3.4c0,0,0,0,0,0c0,0,0,0,0,0c1.1-0.1,2.1,0.2,2.9,1l15,14.9h5.6V0H0v18h8V5.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4,5.1c-0.2,0-0.4,0.2-0.4,0.4v28.9c0,0.3,0.2,0.4,0.4,0.4c0.1,0,0.3,0,0.4-0.1l8.6-8.6h11.5c0.3,0,0.4-0.2,0.4-0.4 c0-0.1,0-0.3-0.1-0.4L11.8,5.2C11.8,5.1,11.6,5.1,11.4,5.1z"
});

var SvgFaceSelect = function SvgFaceSelect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaceSelect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FaceSelect.6ef2df1b.svg";
export { ForwardRef as ReactComponent };